export default "__VITE_ASSET__DAhvmvm1__"